module.exports = __webpack_public_path__ + "static/UNITY-Tower-upper-floor-4-tenants_v2-en-375f73d1a691b89d1526c53653bc7d7f.pdf";